import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../stores/app';
import { listSolutionIdeas } from '../api/solutions';
import { ItemCard } from '../components/ItemCard';
import { EmptyState } from '../components/EmptyState';

export function SolutionList() {
  const sessionId = useAppStore((s) => s.activeSessionId);
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['solutions', sessionId],
    queryFn: () => listSolutionIdeas(sessionId!),
    enabled: !!sessionId,
  });

  if (!sessionId) {
    return (
      <EmptyState
        icon="👆"
        title="Keine Session ausgewählt"
        description="Wähle oben eine Session aus."
      />
    );
  }

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin h-8 w-8 border-4 border-brand-600 border-t-transparent rounded-full" />
      </div>
    );
  }

  const solutions = data ?? [];

  if (solutions.length === 0) {
    return (
      <EmptyState
        icon="💡"
        title="Keine Lösungsideen in dieser Session"
        description="Lösungsideen werden im Wizard generiert."
      />
    );
  }

  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-gray-900">Lösungsideen</h1>
        <span className="text-sm text-gray-500">{solutions.length} Einträge</span>
      </div>

      <div className="grid gap-3">
        {solutions.map((s) => (
          <ItemCard
            key={s.id}
            title={s.name}
            subtitle={s.description ?? undefined}
            meta={`Business Model: ${s.business_model ?? '–'} · Focus: ${s.focus ? 'Ja' : 'Nein'}`}
            onClick={() => navigate(`/solutions/${s.id}`)}
          >
            {s.transformation_statement && (
              <p className="text-xs text-gray-500 italic mt-1 line-clamp-2">
                „{s.transformation_statement}"
              </p>
            )}
          </ItemCard>
        ))}
      </div>
    </div>
  );
}
